export default __webpack_public_path__ + "static/media/map.183eca9d.jpg";